import styled from "styled-components"

export const Container = styled.div`
    width: 950px;
    padding: 16px;
    background: #fff;
    margin-bottom: 48px;
    margin-top: 12px;
    border: solid 1px #707070;
`